module.exports = "/static/media/arrow.b033c494.svg";